import { setIsPlaceholderAttachment } from 'owa-attachment-data';
import setOngoingAction from 'owa-attachment-full-data/lib/actions/setOngoingAction';
import {
    isInlineAttachmentStateType,
    setInlineAttachmentStatus,
    InlineAttachmentStatus,
    ActionType,
} from 'owa-attachment-full-data';
import initializeAttachmentStateForSmimeAttachments from '../actions/initializeAttachmentStateForSmimeAttachments';
import { orchestrator } from 'satcheljs';

export default orchestrator(initializeAttachmentStateForSmimeAttachments, actionMessage => {
    actionMessage.attachments.map(attachmentState => {
        // Reset attachment state because we are downloading attachments
        if (isInlineAttachmentStateType(attachmentState)) {
            setInlineAttachmentStatus(attachmentState, InlineAttachmentStatus.Initialized);
        } else {
            setIsPlaceholderAttachment(attachmentState, true /* isPlaceholder */);
            setOngoingAction(attachmentState, ActionType.Attach);
        }
    });
});
